import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta02Model,
  ConsultaSeguimentoPergunta02ResultadoExameEnum,
} from './model-consultaSeguimentoPergunta02'

const consultaSeguimentoPergunta02ToPerguntaOpcao: Record<
  ConsultaSeguimentoPergunta02ResultadoExameEnum,
  MChatPerguntaOpcaoEnum
> = {
  AUDICAO_ABAIXO: MChatPerguntaOpcaoEnum.AUDICAO_ABAIXO,
  AUDICAO_NORMAL: MChatPerguntaOpcaoEnum.AUDICAO_NORMAL,
  NAO_DEFINITIVO: MChatPerguntaOpcaoEnum.NAO_DEFINITIVO,
}

export const convertConsultaSeguimentoPergunta02ToInput = (
  value: ConsultaSeguimentoPergunta02Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_02_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_02_IGNORA?.IGNORA_SONS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_02_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_02_IGNORA?.IGNORA_PESSOAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_02_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_02_FEZ_EXAME),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_02_04,
      perguntaOpcao: consultaSeguimentoPergunta02ToPerguntaOpcao[value.PERGUNTA_02_RESULTADO_EXAME],
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.perguntaOpcao) || !isUndefinedOrNull(item.stResposta))
}
